import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";

export const screenService = {
    create: async (data) => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.CREATE_SCREEN,
                method: "POST",
                data: data,
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error creating screen:", error);
            throw error;
        }
    },
    update: async (id, data) => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.UPDATE_SCREEN, 
                method: "POST",
                data: {
                    screenId: id,        
                    ...data
                },
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error updating screen:", error);
            throw error;
        }
    },
    getAll: async () => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_SCREENS,
                method: "GET",
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error fetching screens:", error);
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const response = await makeApiRequest({
                endpoint: `${API_ENDPOINTS.GET_SCREEN_BY_ID}/${id}`,
                method: "GET",
                data: { screenId: id },
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error fetching screen:", error);
            throw error;
        }
    },
    delete: async (data) => {
        try {   
            const response = await makeApiRequest({
                endpoint: `${API_ENDPOINTS.DELETE_SCREEN}`,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error deleting screen:", error);
            throw error;
        }
    }
};  